export default function AlertsRouteConfig($stateProvider) {
  'ngInject';

  $stateProvider
    .state('alerts', {
      url: '/alerts',
      template: require('./alerts.main.html'),
      redirectTo: 'alerts.dashboard',
      ncyBreadcrumb: {
        label: "{{'Alerts' | translate}}",
      },
      requiredFeatures: ['alerts'],
    })
    .state('alerts.dashboard', {
      url: '/dashboard',
      controller: 'DashboardMainPageController',
      template: require('./dashboard/dashboard.html'),
      ncyBreadcrumb: {
        label: `{{'Dashboard' | translate}}`,
      },
      requiredFeatures: ['alerts'],
    })
    .state('alerts.history', {
      url: '/history',
      template: `<historical-alerts-list></historical-alerts-list>`,
      ncyBreadcrumb: {
        label: `{{'Historical Alerts' | translate}}`,
      },
      requiredFeatures: ['alerts'],
    })
    .state('alerts.history.details', {
      url: '/details/{instanceId}',
      template: require('./historical-alerts/view/view.html'),
      controller: 'HistoricalAlertsViewController',
      ncyBreadcrumb: {
        label: '{{title}} ' + `{{'Details' | translate}}`,
        parent: 'alerts.history',
      },
      params: {
        alert: null,
      },
      requiredFeatures: ['alerts'],
    })
    .state('alerts.configurations', {
      url: '/configurations',
      template: '<ui-view></ui-view>',
      redirectTo: 'alerts.configurations.list',
      ncyBreadcrumb: {
        label: `{{'Alert Configurations' | translate}}`,
      },
      requiredFeatures: ['alerts', 'alerts.configurations'],
    })
    .state('alerts.configurations.list', {
      url: '/',
      template: require('./configurations/alerts/list/list.html'),
      helpState: 'alerts.configurations',
      ncyBreadcrumb: {
        skip: true,
      },
      controller: 'AlertsListController',
      requiredFeatures: ['alerts', 'alerts.configurations'],
    })
    .state('alerts.configurations.edit', {
      url: '/edit/{configurationId}',
      template: require('./configurations/alerts/view/details/view.html'),
      controller: 'AlertsViewEditController',
      helpState: 'alerts.configurations',
      redirectTo: 'alerts.configurations.edit.equipment',
      ncyBreadcrumb: {
        parent: 'alerts.configurations.list',
        label: '{{configuration.name}}',
      },
      requiredFeatures: ['alerts', 'alerts.configurations'],
    })
    .state('alerts.configurations.edit.equipment', {
      url: '/equipment',
      helpState: 'alerts.configurations',
      template: require('./configurations/alerts/view/assets/assets.html'),
      controller: 'AlertsViewPickAssetsController',
      ncyBreadcrumb: {
        skip: true,
      },
    })
    .state('alerts.configurations.edit.triggers', {
      url: '/triggers',
      helpState: 'alerts.configurations',
      template: require('./configurations/alerts/view/triggers/triggers.html'),
      controller: 'AlertsViewTriggersControllerCRUD',
      ncyBreadcrumb: {
        skip: true,
      },
    })
    .state('alerts.configurations.create', {
      url: '/create',
      template: require('./configurations/alerts/create/create.html'),
      controller: 'AlertsCreateController',
      ncyBreadcrumb: {
        label: `{{'Create Alert Configuration' | translate}}`,
        parent: 'alerts',
      },
      params: {
        rule: null,
      },
      requiredFeatures: ['alerts', 'alerts.configurations.edit'],
    })
    .state('alerts.faults', {
      url: '/faults',
      template: '<ui-view></ui-view>',
      redirectTo: 'alerts.faults.list',
      ncyBreadcrumb: {
        label: `{{'Fault Configurations' | translate}}`,
      },
      requiredFeatures: ['alerts', 'alerts.faults'],
    })
    .state('alerts.faults.list', {
      url: '/',
      template: '<list-fault-config></list-fault-config>',
      helpState: 'alerts.faults',
      ncyBreadcrumb: {
        skip: true,
      },
      requiredFeatures: ['alerts', 'alerts.faults'],
    })
    .state('alerts.faults.edit', {
      url: '/edit/{configurationId}',
      template: '<edit-fault-config></edit-fault-config>',
      helpState: 'alerts.faults',
      params: {
        isEditPage: true,
      },
      ncyBreadcrumb: {
        parent: 'alerts.faults.list',
        label: '{{vm.configuration.name}}',
      },
      requiredFeatures: ['alerts', 'alerts.faults'],
    })
    .state('alerts.faults.create', {
      url: '/create',
      template: '<create-fault-config></create-fault-config>',
      params: {
        isEditPage: false,
      },
      ncyBreadcrumb: {
        label: `{{'Create Fault Configuration' | translate}}`,
        parent: 'alerts',
      },
      requiredFeatures: ['alerts', 'alerts.faults.edit'],
    });
}
